export const selectAuth = state => {
  return (state && state.auth) || {};
};

// 20180711JP: This should probably be normalized like any other entity.
export const selectCurrentUser = state => {
  return selectAuth(state).user;
};
